import { Form } from './Form/Form';
import { FormInputURL } from './FormInputURL';
import { Input, InputError } from './Input';
import { InputDescription } from './InputDescription';
import { KeyValueInput } from './KeyValueInput';
import { Label } from './Label';
import { MultiValueInput } from './MultiValueInput';
import { SecondaryButton } from './SecondaryButton';
import { MultiSelect, ReactSelect } from './Select';
import { ShowPasswordInput } from './ShowPasswordInput';
import { SubmitInput } from './SubmitInput';
import { Switch } from './Switch';
import { TextArea } from './TextArea';

export const FormComponent = {
  Form,
  Label,
  Input,
  InputDescription,
  InputError,
  ShowPasswordInput,
  SubmitInput,
  SecondaryButton,
  TextArea,
  ReactSelect,
  Switch,
  MultiSelect,
  FormInputURL,
  KeyValueInput,
  MultiValueInput,
};
